import React from 'react'

import minimapStyles from './minimap.module.scss'

const Map = props => {
  return (
    <svg
      className={props.className}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 175.1 105.5"
    >
      <g>
        <g>
          <g>
            <path
              className={`${minimapStyles.st1}`}
              d="M56.3,23l4.3-4.4l-2.7-2.8v-2.1L57,12.7L52.8,17h-1.9h-3.5l-0.9,1H43l-1.7-1.8v-1.7l0.9-0.9l-1.9-2L39.7,12
				l0.4,0.4l-1.9,1.9h-4.8l-0.4-0.4h-0.4v0.6l1.1,1.1v1.7h1.6v0.6l-2.4,2.5h-5.6v-1.9h-1.3l-0.7,0.8h-4.4v1.8h0.9v0.6h-0.8v1.6h0.7
				v7.1h-3.6l-4.5,4.7v2.6v1.2l4.1,4.3l1.7-1.8l0.5,0.5v2.7h0.9v-0.6h3.9l2.3-2.4h2.9v3.1l2.9,3h4.3l1.6,1.7l1.2,1.2v4.2h2.5v2.8
				h0.7v8.6l1.4,1.5h3.9l1.3,1.4v3h1.3l0,2.4l1.7,1.8V78v2.3h-1.1l-6.6,6.8l0.7,0.7l0.8-0.8l6.4,6.6l-0.9,0.9l0.7,0.8l7.7-8v-2.4
				l2.4-2.5v-5.1v-2.5h0.9l1.4-1.4h3l2.3-2.4h0.9v-0.5h4.7l2.2-2.2v-2l0,0l2.6-2.7l0-3.7l1.4-1.4V49l1.7-1.7l0.4,0.4l1.8-1.9l0,0
				l1.9-1.9 M77.7,26.7h-1.1v0h-2.2l-1-1h-2.3v-0.9l-1.6-1.6l-1.8,1.3l0-0.8L66,23.3l-1.4-1.5l-3.9,4l-2.9-2.9l-2.3,2.4l-0.7-0.7
				l1.5-1.5 M85.7,30.4l-2.3-2.4h-2.5l-1.2-1.2h-2 M87.8,43.9l2.6-2.6v-1.6v-1.1l0.6-0.6v-1.7v-1.6l0-1.5l-1.8-1.9h-2.5l-0.8-0.9
				 M26.8,41.3"
            />
            <polygon
              className={`${minimapStyles.st1}`}
              points="58,22.3 60.6,24.8 63.6,21.6 62.5,20.4 61.1,20.4 60.4,19.7 			"
            />
          </g>
        </g>
        <rect
          x="100.1"
          y="32.7"
          className={`${minimapStyles.st2}`}
          width="68.1"
          height="43.3"
        />
        <text transform="matrix(1 0 0 1 100.0992 38.824)">
          <tspan x="0" y="0" className={`${minimapStyles.st3}`}>
            REGIÃO{' '}
          </tspan>
          <tspan x="0" y="11.6" className={`${minimapStyles.st3}`}>
            NO NORTE{' '}
          </tspan>
          <tspan x="0" y="23.3" className={`${minimapStyles.st3}`}>
            DE MINAS{' '}
          </tspan>
          <tspan x="0" y="34.9" className={`${minimapStyles.st3}`}>
            GERAIS
          </tspan>
        </text>
        <rect
          x="67.3"
          y="49.5"
          className={`${minimapStyles.st6}`}
          width="9"
          height="7"
        />
      </g>
    </svg>
  )
}

export default Map
